// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"83101a3a","57":"d67e35e5","353":"1a32fba3","449":"7d36677e","453":"45849238","660":"582ca9ea","697":"01bc5add","712":"f0df328a","802":"32c15162","819":"f02f4fe9"}[chunkId] + ".chunk.js";
};